<template>
<div id="aduanas-grupo">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Administrar Aduanas de Grupo" class="elevation-1 px-5 py-3">

          <v-card-text>
            <v-card>

              <v-container fluid fill-height>
                <v-layout row wrap>
                  <v-flex col xs6 s6 m6 l6>
                    <h4>
                      <v-icon>list</v-icon> Aduanas disponibles
                    </h4>
                    <v-divider />
                    <v-card-text>
                      <v-list dence v-for="(aduana, el) in aduanas" :key="el">
                        <v-list-item @click="seleccionar(aduana)">
                          <v-list-item-content>
                            <v-list-item-subtitle>{{aduana.clave + " - " + aduana.nombre }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon color="success">fa-forward</v-icon>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-flex>

                  <v-flex col xs6 s6 m6 l6 style="border-left: 1px solid; !important">
                    <h4>
                      <v-icon>check</v-icon> Aduanas en que opera el grupo
                    </h4>
                    <v-divider />
                    <v-card-text>
                      <div v-if="selected.length === 0" key="title" class="title font-weight-light grey--text pa-3 text-xs-center">
                        Seleccione las aduanas en que opera
                      </div>

                      <v-list dense v-for="(seleccionada, el) in selected" :key="el">
                        <v-list-item @click="remover(seleccionada)">
                          <v-list-item-action>
                            <v-icon color="error">fa-backward</v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>{{seleccionada.clave + " - " + seleccionada.nombre }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn class="white--text" color="green darken-1" @click="guardar" :loading="loading">
                  <v-icon right>done</v-icon> Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card-text>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  data: () => ({
    fab: false,
    show_loading: true,
    loading: false,
    URL: "",
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Utilerías",
        disabled: true,
        to: ""
      },
      {
        text: "Aduanas Grupo",
        disabled: true,
        to: ""
      }
    ],
    grupo: null,
    aduanas: [],
    selected: []
  }),

  methods: {
    seleccionar(aduana) {
      this.selected = this.removerElementoArray(this.selected, aduana);
      this.selected.push(aduana);
      this.selected.sort(this.ordenarArray);
      this.aduanas = this.removerElementoArray(this.aduanas, aduana);
    },
    remover(aduana) {
      this.aduanas = this.removerElementoArray(this.aduanas, aduana);
      this.aduanas.push(aduana);
      this.aduanas.sort(this.ordenarArray);
      this.selected = this.removerElementoArray(this.selected, aduana);
    },
    removerElementoArray: function(arr, value) {
      return arr
        .filter(function(ele) {
          return ele.id_aduana != value.id_aduana;
        })
        .sort(this.ordenarArray);
    },
    ordenarArray: function(a, b) {
      if (a.clave > b.clave) return 1;
      if (a.clave < b.clave) return -1;
      return 0;
    },
    async getAduanas() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      await axios
        .get(this.$hostname + "catalogos/aduanas/")
        .then(res => {
          this.aduanas = res.data;
        })
        .catch(err => {
          
          console.log(err);
        });

      await axios
        .post(this.$hostname + "catalogos/aduanas_grupo/get_aduanas/", {
          grupo: this.grupo
        })
        .then(res => {
          var datos = res.data;
          //obtenemos solo las aduanas
          this.selected = datos.reduce(function(acumulador, valorActual) {
            acumulador.push(valorActual.aduana);
            return acumulador;
          }, []);

          this.selected.forEach(element => {
            this.seleccionar(element);
          });
        })
        .catch(err => {
          this.$swal({
            position: "center",
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener las aduanas del grupo"
            //showConfirmButton: false,
          });
          console.log(err);
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    guardar() {
      var idSeleccionados = this.selected.reduce(function(
          acumulador,
          valorActual
        ) {
          acumulador.push(valorActual.id_aduana);
          return acumulador;
        },
        []);
      var datos = {
        grupo: this.grupo,
        aduanas: idSeleccionados
      };
      console.log(idSeleccionados);
      console.log(datos);

      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var metodo = "post";
      var urlCliente = this.$hostname + "catalogos/aduanas_grupo/guardar_aduanas/";
      axios({
          method: metodo,
          url: urlCliente,
          data: datos
        })
        .then(res => {
          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "Los datos se guardaron correctamente",
            footer: ""
          });
        })
        .catch(error => {
          this.$swal({
            position: "center",
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al guardar los datos"
            //showConfirmButton: false,
          });
          console.log(error);

        })
        .then(() => {
          this.$root.$dialogLoader.hide();
          this.getAduanas();

        });
    }
  }, //methods
  created: function() {
    this.URL = "http://localhost:8000/catalogos/aduanas_grupo/";
    this.grupo = this.$local_storage.get("id_grupo");
    this.getAduanas();
  }
};
</script>
